/**
 * 博士路由信息
 */
export default {
  name: 'examDoctor',
  path: 'examDoctor',
  component: resolve => require(['../../components/pages/examDoctor'], resolve),
  redirect: 'examDoctor/healthReport',
  children: [{
    path: 'healthReport',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorHealthReport'], resolve)
  }, {
    path: 'submitHonor',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorHonor'], resolve)
  }, {
    path: 'materialSubmit',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorMaterialSubmit'], resolve)
  }, {
    path: 'materialDownload',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorMaterialDownload'], resolve)
  }, {
    path: 'politicalTrialSubmit',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorPoliticalTrialSubmit'], resolve)
  }, {
    path: 'queryResult',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorQueryResult'], resolve)
  }, {
    path: 'contactSupplement',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorContactSupplement'], resolve)
  }, {
    path: 'certificateExamine',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorCertificateExamine'], resolve)
  }, {
    name: 'admissionNotice',
    path: 'admissionNotice',
    component: resolve => require(['../../components/pages/examDoctor/reexamine/ExamDoctorEnrollNoticeExpressQuery'], resolve)
  }]
}



// WEBPACK FOOTER //
// ./src/router/pages/examDoctor.js